import React, { createContext, ReactNode, useContext, useMemo, useState } from 'react';
import { JobDetailRowType } from '../components/Pages/JobStatus/Details/TabsContent/JobDetails/jobDetailsData';
import { DeliveryInfoRowType } from '../components/Pages/JobStatus/Details/TabsContent/DeliveryInfo/deliveryInfoData';
import {
  DeliveryInfoColumnType,
  GeoDeliveryColumnType,
  JobDetailColumnType,
} from '../components/Pages/JobStatus/Details/TabsContent/subTableConfig';

interface SelectedTableProps {
  row: JobDetailRowType | DeliveryInfoRowType | null | string;
  column: JobDetailColumnType | DeliveryInfoColumnType | GeoDeliveryColumnType | null;
}

interface JobDetailsProviderProps {
  selectedTable: SelectedTableProps;
  handleSelectedTable: (props: SelectedTableProps) => void;
}

const defaultValue: JobDetailsProviderProps = {
  selectedTable: { row: null, column: null },
  handleSelectedTable: () => undefined,
};

export const JobDetailsContext = createContext<JobDetailsProviderProps>(defaultValue);

function JobDetailsProvider({ children }: { children: ReactNode }) {
  const [selectedTable, setSelectedTable] = useState<SelectedTableProps>(defaultValue.selectedTable);

  const handleSelectedTable = (props: SelectedTableProps) => {
    setSelectedTable(props);
  };

  const memoizedValue: JobDetailsProviderProps = useMemo(
    () => ({
      selectedTable,
      handleSelectedTable,
    }),
    [selectedTable, handleSelectedTable],
  );

  return <JobDetailsContext.Provider value={memoizedValue}>{children}</JobDetailsContext.Provider>;
}

export default JobDetailsProvider;

export const useJobDetailsProvider = (): JobDetailsProviderProps => useContext(JobDetailsContext);
